import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faCheck, faPen, faXmark } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { ModalUsuariosProps } from "../../views/Usuarios"
import TagsDepartamentos from "../TagsDepartamentos"

const USUARIOS_COLUMNS = (
  t: TFunction,
  openEditModal: Dispatch<SetStateAction<ModalUsuariosProps>>
) => {
  const columns = [
    {
      key: "nombre",
      header: `${t("gestionUsuarios.users.table.name")}`,
      field: "nombre",
      style: { width: "10%" },
      sortable: true,
      sortField: "Persona.Nombre",
    },
    {
      key: "apellidos",
      header: `${t("gestionUsuarios.users.table.subName")}`,
      field: "apellidos",
      style: { width: "10%" },
      sortable: true,
      sortField: "Persona.Apellidos",
    },
    {
      key: "email",
      header: `${t("gestionUsuarios.users.table.email")}`,
      field: "email",
      style: { width: "10%" },
      sortable: true,
      sortField: "email",
    },
    {
      key: "departamentos",
      header: `${t("gestionUsuarios.users.table.departament")}`,
      field: "departamentos",
      style: { width: "55%" },
      sortable: true,
      sortField: "DepartamentoUsuarios.Count",
      body: (rowData: UsuarioReadingFiltersDtoProps) =>
        TagsDepartamentos({
          departamentos: rowData.departamentos,
        }),
    },
    {
      key: "verificado",
      header: `${t("gestionUsuarios.users.table.verified")}`,
      field: "verificado",
      style: { width: "10%" },
      bodyClassName: "!tw-text-center",
      alignCol: "center",
      body: (rowData: UsuarioReadingFiltersDtoProps) =>
        FontAwesomeIcon({
          icon: rowData.verificado ? faCheck : faXmark,
          className: `tw-pt-1 tw-size-5 ${
            rowData.verificado ? "tw-text-secondary" : "tw-text-primary-25"
          }`,
        }),
    },
    {
      key: "actionButton",
      field: "actionButton",
      style: { width: "5%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: UsuarioReadingFiltersDtoProps) => (
        <OptionsMenuStorybook
          id={rowData.id}
          items={[
            {
              title: `${t("gestionUsuarios.users.table.edit")}`,
              hasRedirect: true,
              action: () => {
                openEditModal({ rowData, isOpen: true })
              },
              icon: faPen,
            },
          ]}
          position='right'
        />
      ),
    },
  ]
  return columns
}

export default USUARIOS_COLUMNS
